import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';

import Service from '@/service/index.js';
import { mapGetters } from 'vuex';

export default {
  components: {
    Header,
    Search,
    Menu,
    Bottom,
    ProcessNavigation
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'getTenantParams'
    ])
  },
  data() {
    return {
      id: '',
      oldId: '',
      activeIndex: 0,
      tableList: ['农村土地经营权流转交易流程图', '农村集体资源性资产流转交易流程图', '农村集体经营性资产流转交易流程图'],
      processList: ['业务流程及准备材料', '编辑项目信息', '编辑受让资格', '上传附件信息', '重大事项提示', '承诺信息', '提交申请'],
      ruleForm: {
        type: '',
        name: '',
        idCard: '',
        mobile: '',
        householdsType: '',
        address: '',
        companyName: '',
        creditCode: '',
        email: '',
        legalName: '',
        legalMobile: '',
        legalIdType: '',
        legalIdCard: '',
        assignor: '',
        assignorIdType: '',
        assignorIdCard: '',
        assignorMobile: ''
      },
      citytitle: '',
      assetsId: '',
      accessToken: '',
      username: '',
      mobile: '',
      type: '',
      firstLogin: '',
      userCode: '',
      userId: ''
    };
  },
  created () {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;

    this.assetsId = this.$route.query.assetsId;
    this.accessToken = this.$route.query.accessToken;
    this.username = this.$route.query.username;
    this.mobile = this.$route.query.mobile;
    this.type = this.$route.query.type;
    this.firstLogin = this.$route.query.firstLogin;
    this.userCode = this.$route.query.userCode;
    this.userId = this.$route.query.userCode;
    if (this.assetsId && this.accessToken) {
      this.$store.commit('SET_USER_INFO', {});
      window.localStorage.clear();
      this.$store.commit('SET_TRADE_TYPE', 1);
      let resData = {
        username: this.username,
        mobile: this.mobile,
        type: this.type,
        accessToken: this.accessToken,
        firstLogin: this.firstLogin,
        userCode: this.userCode,
        userId: this.userId
      };
      this.$store.commit('SET_USER_INFO', resData);
    } else {
      Service.getUserBaseInfo().then(res => {
        if (!res.data) {
          return;
        }
        Object.keys(this.ruleForm).forEach((key) => {
          this.ruleForm[key] = res.data && String(res.data[key]);
        });
      });
    }
  },
  methods: {
    next() {
      // let str = '';
      // if (this.id && this.oldId) {
      //   str = '?id=' + this.id + '&oldId=' + this.oldId;
      // } else if (this.id) {
      //   str = '?id=' + this.id;
      // } else if(this.oldId) {
      //   str = '?oldId=' + this.oldId;
      // }
      // this.$router.push('/publish-project/project-info' + str);

      this.$router.push({
        path: '/publish-project/project-info',
        query: this.$route.query
      });
    },
    // 下载模版
    downTemplate(type) {
      if(type === 1) {
        window.open('/资产资源权属证明模板.pdf');
      } else {
        window.open('/关于同意资产再流转的意见.pdf');
      }
    }
  }
};
